<template lang="pug">
  .container-main-mobile#container-main-mobile
    header.container-mobile-header(v-if="!isReg")
      .header-logo(@click="toggleMenu")
        fa-icon(:icon="['fas', 'bars']").menu-button
        h1 富慧通
      .header-toolbox
        .header-toolbox-content.header-username
          fa-icon(icon="user")
          span {{ userInfo.uname }}
        .header-toolbox-content.header-logout(@click="exit")
          fa-icon(icon="sign-out-alt")
          span 注销

    .content-container#content-container
      .menu-mobile-container#menu-container(:class="{ 'display-none': isCollapse }")
        el-menu(router, :collapse="isCollapse", @select="closeMenu").menu
          el-menu-item(index="100", route="/main-mobile").menu-item 商家资料
          el-menu-item(index="200", route="/payment-mobile").menu-item 收款账户管理
          //- el-menu-item(index="300", route="/roleList").menu-item 角色列表
          //- el-menu-item(index="400", route="/childAccountList").menu-item 子账号列表
          el-menu-item(index="500", route="/editPassword-mobile").menu-item 修改密码
          
      .container-router-view(@click="closeMenu")
        slot
    
        footer.container-copyright 
          .copyright-content ©2018-2021Guangzhou ThinkinPower Internet Technology Co., Ltd. 版权所有 广州市思力智慧互联网科技有限公司
          .copyright-content 粤ICP备16101578号 粤公网安备44010602001961号
</template>

<script>
export default {
  data () {
    return {
      menuList:     [],
      menuLoading:  false,

      unreadSysMsgCount:  1,

      isDesktop:  true,
      isCollapse: true,
    };
  },
  computed: {
    isLogin () {
      return this.$store.getters.isLogin;
    },
    userInfo () {
      return this.$store.getters.userInfo;
    },
    isReg () {
      const name = this.$route.name;
      return name && name.match(/reg/);
    },
    showToolbox () {
      return this.userInfo.fill_info === 2;
    },
  },
  methods:  {
    getMenuList () {
      this.menuLoading = true;
      return this.$store.dispatch('GET_MENU_LIST').catch(({ code, msg }) => {
        this.$alert(`系统菜单获取失败：${code}：${msg}`, {
          type:     'error'
        });
      }).finally(() => {
        this.menuLoading = false;
      });
    },
    createMenuList (data) {
      this.menuList = data;
    },

    toggleMenu () {
      this.isCollapse = !this.isCollapse;
    },
    openMenu () {
      this.isCollapse = false;
    },
    closeMenu () {
      this.isCollapse = true;
    },

    mainPage () {
      this.$router.push('/');
    },
    logout () {
      this.$store.dispatch('LOGOUT');
    },
    exit () {
      this.logout();
    },
  },
  mounted () {
    window.onresize = () => {
      this.isDesktop = window.screen.width >= 500;
    };
    window.onresize();
  }
};
</script>

<style lang="less">
@import (reference) "../assets/general";

.container-main-mobile {
  .border-box;
  .max-width;
  .max-height;

  .el-dialog__header {
    padding:  15px 20px 10px;
  }

  .el-dialog__body {
    padding:  20px 0;
    background:   @background-grey-2;
  }

  .container-header {
    .border-box;
    .flex(normal, space-between);
    .max-width;
    
    height:       60px;
    color:        @font-color-black;

    h1 {
      .display-flex;
      padding:    15px 0;
      font-size:  18px;

      span {
        height:       30px;
        line-height:  30px;
        .cursor-default;
      }
    }
  }

  .container-mobile-header {
    .border-box;
    .max-width;
    .flex(normal, space-between);

    height:       40px;
    color:        @font-color-black;
    background:   @background-blue;

    .header-toolbox {
      color:    @white;
      font-size:    12px;
    }

    .header-logo {
      padding-left:   0;
    }
  }

  .header-logo {
    .border-box;
    .flex(center, center);

    width:          200px;
    background:     @background-blue;

    h1 {
      .bold;
      font-size:    20px;
      color:        @white;

      @media screen and (max-width: 360px) {
        font-size:    18px;
      }
    }

    @media screen and (max-width: 500px) {
      width:        auto;
    }
  }

  .header-nav-container {
    .inline-flex(center, normal);
    flex:     2;
  }

  .header-nav {
    .inline-flex(center, normal);
    .max-height;
  }

  .header-nav-item {
    .border-box;
    .display-block;
    .align-center;
    .cursor-pointer;

    width:      96px;
    color:      @font-color-black;
    font-size:  14px;
    text-decoration: none;

    &:hover, &.active {
      font-size:  18px;
      color:      @font-color-black;
      text-decoration: none;
    }
    &:active, &focus {
      color:      @font-color-black;
      text-decoration: none;
    }
  }

  .nav-selected {
    font-size:  18px;
  }

  .header-toolbox {
    .inline-flex(center, center);
    .max-height;
  }
  .header-toolbox-content {
    margin:         0 1em;

    @media screen and (max-width: 360px) {
      margin:       0 .5em;
    }

    svg+span, span+svg {
      margin-left:    .5em;
    }
  }

  .header-logout, .header-notice {
    .cursor-pointer;
  }

  .header-bell {
    .cursor-pointer;
    margin-right:   3em;

    .el-badge__content {
      top:          2px;
      right:        2px;
      padding:      0, 4px;
      border:       none;

      height:       14px;
      line-height:  14px;
    }
  }

  .content-container {
    .border-box;
    .flex();
    width:        auto;
    min-height:   e("calc(100% - 60px)");
    min-width:    800px;

    @media screen and (max-width: 500px) {
      min-height:   e("calc(100% - 40px)");
      width:  100%;
      min-width:    0;
    }
  }

  .menu-container {
    overflow:     auto;

    width:        200px;
    min-width:    200px;
    background:   @background-menu;

    a {
      text-decoration: none;
    }
    h1 {
      .flex();
      padding:    20px 0;
      font-size:  18px;

      span {
        height:       30px;
        line-height:  30px;
      }
    }
    .menu {
      border-right: 0;
    }
    .menu-header {
      height:     70px;
      background: @font-color-blue;
    }

    .menu-item {
      height:     50px;
      line-height:50px;

      font-size:  @font-size-normal;
      color:      @font-color-menu-item;
      background: @background-menu;

      border-top: 1px solid @border-menu-item;

      &:hover  {
        color:      @white;
        background: @background-blue-active;
      }

      &:last-child {
        border-bottom:  1px solid @border-menu-item;
      }
    }

    .menu-sub {
      border-top:   1px solid @border-menu-item;

      .menu-sub-title {
        color:      @font-color-menu-item;
      }

      &:hover .menu-sub-title {
        color:      @white;
      }

      &:last-child {
        border-bottom:  1px solid @border-menu-item;
      }
    }

    .menu-sub-item {
      background:           @background-sub-menu;
      border:               none;
      list-style-type:      disc;
      list-style-position:  inside;
    }

    .active .menu-item {
      color:      @white;
      background: @background-blue;
    }
    .is-active {
      color:      @white;
      background: @background-blue;
    }
  }
  .menu-mobile-container {
    &:extend(.menu-container);

    .position-absolute;
    left:   0;
    width:      auto;
    min-width:  0;
    z-index:    100;

    .menu {
      border-right:   1px solid @border-menu-item;
    }

    .menu-item {
      width:          200px;
      border-top:     0;
      border-bottom:  1px solid @border-menu-item;

      font-size:  @font-size-normal;
      color:      @font-color-menu-item;
      background: @background-menu;
    }

    .el-menu--collapse {
      width:  0;
      border-right:   0;
    }
  }

  .menu-button {
    .inline-flex(center, center);
    color:  @white;
    padding:  0 15px;

    @media screen and (max-width: 360px) {
      padding:  0 10px;
    }
  }

  .container-router-view {
    .flex(normal, space-between, column);
    .max-width;
    overflow:         auto;

    background:       @background-grey;
  }
}
</style>